if (!customElements.get('tabs-advantages')) {
  customElements.define('tabs-advantages', class TabsAdvantages extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.tabs-advantages__button');
      this.panes = this.querySelectorAll('.tabs-advantages__pane');
      
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.switchTab(button));
      });
    }

    switchTab(selectedButton) {
      if (selectedButton.classList.contains('is-active')) return;

      const targetId = selectedButton.getAttribute('data-target');
      const targetPane = this.querySelector(`#${targetId}`);

      // Сбрасываем состояния кнопок и панелей
      this.buttons.forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      });

      this.panes.forEach(pane => {
        pane.classList.remove('is-active');
        pane.classList.remove('is-animated'); // Чистим старую анимацию
      });

      // Активируем выбранный таб
      selectedButton.classList.add('is-active');
      selectedButton.setAttribute('aria-selected', 'true');
      
      if (targetPane) {
        targetPane.classList.add('is-active');
        // Добавляем класс анимации в следующем кадре, чтобы браузер успел его отрендерить
        requestAnimationFrame(() => {
          targetPane.classList.add('is-animated');
        });
      }
    }
  });
}